import type { ReactNode } from 'react'
import { Navbar } from './navbar'
import { Footer } from './footer'

interface PageLayoutProps {
  children: ReactNode
}

/** Standard page shell: sticky header + content + footer. */
export function PageLayout({ children }: PageLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  )
}
